import React from "react"
import { Box, Typography } from "@mui/material"
import { truncateString } from "@utils"
import { CardSeeker } from "@ui-seeker/core"


export default function ReportFormDrawerCsvFileName({ file }) {

	if (!file?.name || !file?.size) return null

	return <CardSeeker
		variant="outlined"
		sx={{ height: 35, display: 'inline-flex', alignItems: 'center', p: 1, borderRadius: '6px' }}
	>
		<Box sx={{ display: 'flex', flexDirection: 'row', overflow: 'hidden', whiteSpace: 'nowrap' }}>
			<Typography sx={{ fontWeight: 'bold', mr: 1, ml: 0 }}>Name: </Typography>
			<Typography> {truncateString(file?.name || "", 28)} | </Typography>
			<Typography sx={{ fontWeight: 'bold', mx: 1 }}>Size: </Typography>
			<Typography> {file?.size} KB</Typography>
		</Box>
	</CardSeeker>
}